import { markRaw } from 'vue';
import Webform from '../Webform/Webform.vue';
import SimpleHTML from '../SimpleHTML/SimpleHTML.vue';

export default {
  props: {},

  components: {
    Webform,
  },

  mounted() {},

  data() {
    return {
      cmpLibrary: markRaw({
        SimpleHTML,
      }),
      defaults: {},
    };
  },

  computed: {},

  methods: {},

  watch: {},
};
